import { FC, FunctionComponent } from 'react';
import { InternalDrawer } from '../InternalDrawer/InternalDrawer';

type Props = {
  drawer: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Drawer: FunctionComponent<any>;
    isOpen: boolean;
    toggle: () => void;
    open: () => void;
    close: () => void;
  };
  drawers: {
    type: string;
    component: JSX.Element;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    drawerProps?: Record<string, any>;
    claimKey?: string;
    customLabel?: string;
  }[];
  type: string | undefined;
};

export const DrawersList: FC<Props> = ({ drawer, drawers, type }) => {
  return (
    <>
      {drawers.map(drawerInstance => {
        if (drawerInstance.type === type) {
          return (
            <InternalDrawer
              key={`${drawerInstance.type}`}
              Drawer={drawer.Drawer}
              isOpen={drawer.isOpen}
              drawerProps={drawerInstance.drawerProps || undefined}
              onClose={drawer.close}
            >
              {drawerInstance.component}
            </InternalDrawer>
          );
        }
        return null;
      })}
    </>
  );
};
